import React from 'react'
import "./Loader.css"

const Loader = () => {
  return (
    <div className="spinner-border spinner-border-reverse align-self-center text-dark my-auto custom-loader"
          style={{marginTop : "50%"}}></div>
  )
}

export default Loader